var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6.9999C11.5 8.19311 11.026 9.33744 10.1823 10.1812C9.33857 11.0249 8.19423 11.4989 7.00102 11.4989C5.80781 11.4989 4.66347 11.0249 3.81975 10.1812C2.97602 9.33744 2.50202 8.19311 2.50202 6.9999C2.50202 5.80669 2.97602 4.66235 3.81975 3.81862C4.66347 2.9749 5.80781 2.5009 7.00102 2.5009C8.19423 2.5009 9.33857 2.9749 10.1823 3.81862C11.026 4.66235 11.5 5.80669 11.5 6.9999ZM10.68 11.7399C9.4744 12.6759 7.95739 13.1172 6.43782 12.974C4.91825 12.8309 3.51036 12.114 2.50077 10.9693C1.49117 9.82461 0.95577 8.3382 1.00355 6.81265C1.05134 5.2871 1.67872 3.8371 2.75797 2.75785C3.83723 1.6786 5.28722 1.05122 6.81277 1.00343C8.33832 0.955648 9.82473 1.49105 10.9694 2.50065C12.1141 3.51024 12.831 4.91813 12.9742 6.4377C13.1173 7.95726 12.676 9.47427 11.74 10.6799L14.78 13.7199C14.8537 13.7886 14.9128 13.8714 14.9538 13.9634C14.9948 14.0554 15.0168 14.1547 15.0186 14.2554C15.0204 14.3561 15.0019 14.4561 14.9641 14.5495C14.9264 14.6429 14.8703 14.7277 14.7991 14.7989C14.7278 14.8702 14.643 14.9263 14.5496 14.964C14.4562 15.0017 14.3562 15.0203 14.2555 15.0185C14.1548 15.0167 14.0555 14.9947 13.9635 14.9537C13.8715 14.9127 13.7887 14.8536 13.72 14.7799L10.68 11.7399Z",
    fill: "#01459D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c8b925d135da2ec31d8be3fc135298b5.svg";
export { ForwardRef as ReactComponent };